<script>
  import {
    Modal,
    Grid,
    Row,
    Column,
    ImageLoader,
  } from "carbon-components-svelte";
  import { createEventDispatcher } from "svelte";
  // import ConfirmModal from "./ConfirmModal.svelte";
  import BaseModal from "./BaseModal.svelte";

  const dispatch = createEventDispatcher();
  export let open;
  export let sampleDocs;
  let confirmOpen = false;
  let selectedDoc = null;
  let confirmObj;

  function selectedItem(doc) {
    selectedDoc = doc;
  }

  function submit() {
    if (selectedDoc != null) dispatch("submit", { doc: selectedDoc });
  }
  $: if (open == false) {
    selectedDoc = null;
  }
</script>

<BaseModal
  bind:show={open}
  onClose={() => (open = false)}
  title="페이지추가"
  width={930}
  disableOverlayClose={true}
  on:submit={submit}
  class="sample-doc-modal"
  primaryButtonDisabled={selectedDoc === null ? true : false}
>
  <style>
    .sample-doc-modal > .bx--modal-container {
      width: 930px;
    }
    .list-wrapper {
      display: grid;
      grid-template-columns: repeat(auto-fill, 166px);
      padding: 30px;
      gap: 50px;
    }
    .img-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 166px;
      height: 234px;
      text-align: center;
      background: rgb(0, 0, 0);
      overflow: hidden;
      border: 1px solid #eaeaea;
    }
    .active {
      border: 3px solid red;
    }
    .label-text {
      margin-top: 10px;
      font-size: 13px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: center;
      color: rgb(44, 44, 44);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  </style>
  <div class="list-wrapper">
    {#each sampleDocs as doc (doc.id)}
      <div
        class="list-item"
        on:dblclick={async () => {
          selectedItem(doc);
          submit();
        }}
        on:click={() => selectedItem(doc)}
      >
        <div class="img-wrapper" class:active={selectedDoc?.id === doc.id}>
          <ImageLoader src="data:image/png;base64,{doc.thumbnail}" />
        </div>
        <div class="label-text">{doc.name}</div>
      </div>
    {:else}
      <p>없음</p>
    {/each}
  </div>
</BaseModal>
<!-- <Modal
    class="sample-doc-modal"
    bind:open
    modalHeading="페이지추가"
    on:open
    on:close

    primaryButtonText="확인"
    on:submit={submit}
    primaryButtonDisabled={ selectedDoc === null ? true : false}
>
    <style>
        .sample-doc-modal > .bx--modal-container {
            width: 930px;
        }
        .list-wrapper {
            display: grid;
            grid-template-columns: repeat(auto-fill, 166px);
            padding: 30px;
            gap: 50px;
        }
        .img-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 166px;
            height: 234px;
            text-align: center;
            background: rgb(0, 0, 0);
            overflow: hidden;
        }
        .active {
            border: 3px solid red;
        }
        .label-text {
            margin-top: 10px;
            font-size: 13px;
            font-weight: 400;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            text-align: center;
            color: rgb(44, 44, 44);
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    </style>
    <div class="list-wrapper">
        {#each sampleDocs as doc (doc.id)}
            <div class="list-item" on:dblclick={async() => {selectedItem(doc);submit()}} on:click={() => selectedItem(doc)}>
                <div class="img-wrapper" class:active={ selectedDoc?.id === doc.id }>
                    <ImageLoader src="data:image/png;base64,{doc.thumbnail}" />
                </div>
                <div class="label-text">{doc.name}</div>
            </div>
        {:else}
            <p>없음</p>
        {/each}
    </div>
</Modal> -->
<!-- <ConfirmModal bind:open={confirmOpen} {confirmObj} /> -->
